export default __webpack_public_path__ + "static/media/BonusBenefits.320de0db.svg";